import React from 'react';

export function VideoPlayer({ videoUrl, title }) {
  if (!videoUrl) {
    return null;
  }

  // Chuyển đổi YouTube link thường thành embed link nếu cần
  let embedUrl = videoUrl;
  if (videoUrl.includes('youtube.com/watch?v=')) {
    const videoId = videoUrl.split('v=')[1]?.split('&')[0];
    embedUrl = `https://www.youtube.com/embed/${videoId}`;
  } else if (videoUrl.includes('youtu.be/')) {
    const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
    embedUrl = `https://www.youtube.com/embed/${videoId}`;
  }

  const isEmbed = embedUrl.includes('youtube.com/embed') || embedUrl.includes('player.vimeo.com');

  return (
    <div
      style={{
        position: 'relative',
        paddingBottom: '56.25%', // Tỷ lệ chuẩn 16:9
        height: 0,
        overflow: 'hidden',
        borderRadius: 8,
        background: '#000000',
        marginBottom: 20,
      }}
    >
      {isEmbed ? (
        <iframe
          src={embedUrl}
          title={title || 'Video bài giảng'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
        />
      ) : (
        <video
          src={embedUrl}
          controls
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      )}
    </div>
  );
}
